import {
  IMagnoliaContext,
  MgnlContent,
  MgnlTemplateAnnotations,
} from '@magnolia/frontend-helpers-base';
import { GlobalRef, StoreConstants } from '../shared';
import { MagnoliaConfig } from '../types';

export const setConfigRef = <T extends MagnoliaConfig>(config: T) => {
  new GlobalRef(StoreConstants.CONFIG_STORE_ID).setValue(config);
};

export const getConfigRef = <T extends MagnoliaConfig>() => {
  return new GlobalRef<T>(StoreConstants.CONFIG_STORE_ID).getValue();
};

export const setTemplateAnnotationsRef = <T extends MgnlTemplateAnnotations>(
  templateAnnotations: T
) => {
  new GlobalRef(StoreConstants.TEMPLATE_ANNOTATIONS_STORE_ID).setValue(
    templateAnnotations
  );
};

export const getTemplateAnnotationsRef = <
  T extends MgnlTemplateAnnotations,
>() => {
  return new GlobalRef<T>(
    StoreConstants.TEMPLATE_ANNOTATIONS_STORE_ID
  ).getValue();
};

export const setContentRef = <T extends MgnlContent>(content: T) => {
  new GlobalRef(StoreConstants.CONTENT_STORE_ID).setValue(content);
};

export const getContentRef = <T extends MgnlContent>() => {
  return new GlobalRef<T>(StoreConstants.CONTENT_STORE_ID).getValue();
};

export const setMagnoliaContextRef = <T extends IMagnoliaContext>(
  magnoliaContext: T
) => {
  new GlobalRef(StoreConstants.MGNL_CONTEXT_STORE_ID).setValue(magnoliaContext);
};

export const getMagnoliaContextRef = <T extends IMagnoliaContext>() => {
  return new GlobalRef<T>(StoreConstants.MGNL_CONTEXT_STORE_ID).getValue();
};
